import { type MaybeRefOrGetter } from "vue";
import RoomInfoService, {
  type RoomInfoFilters,
  type TRoomInfoList,
} from "@/api/models/message/room-info";
import { useGenericPaginatedQuery, createQueryKeys } from "@/composables/shared/queries";

// --------------------
// Queries
// --------------------

export const RoomInfoQueryKeys = createQueryKeys(RoomInfoService.queryKey, (key) => ({
  paginatedList: key<RoomInfoFilters>("paginated"),
}));

export const usePatientRoomInfoInfiniteQuery = (
  filters: MaybeRefOrGetter<Partial<RoomInfoFilters>>,
  enabled: MaybeRefOrGetter<boolean> = true
) => {
  return useGenericPaginatedQuery<TRoomInfoList, RoomInfoFilters>({
    queryKey: RoomInfoQueryKeys.paginatedList(),
    params: { filters, enabled },
    fetcher: async (params) =>
      await RoomInfoService.getPatientRoomInfo(
        { patientId: params.filters.patientId! },
        params.filters,
        params.pageParam
      ),
    neededKey: ["patientId"],
    permission: $permSubjects.PATIENT__PATIENT,
    suppressErrors: [404],
  });
};
